export const contentContainer = {
  width: "100%",
  padding: "40px",
  display: "flex",
  flexDirection: "column",
  zIndex: 100,
};

export const modalTitle = {
  textTransform: "uppercase",
  paddingBottom: "20px",
  borderBottom: "solid 4px",
  borderColor: "grey9",
  marginBottom: "20px",
  lineHeight: "30px",
};

export const descriptionText = {
  marginBottom: "20px",
  letterSpacing: "0.05em",
};

export const subText = {
  ...descriptionText,
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: "500",
};

export const marketingBox = {
  display: "flex",
  margin: "15px 0",
};

export const marketingCheckbox = {
  margin: "5px",
  display: "flex",
  justifyContent: "center",
  alignContent: "center",
  padding: "5px 0",
};

export const marketingSubTitle = {
  margin: "10px",
  padding: "10px",
};

export const emailInput = {
  textTransform: "uppercase",
  padding: "20px 0px",
  letterSpacing: "0.05em !important",
  marginBottom: "20px",
};

export const buttonsContainer = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  borderTop: "solid 1px",
  borderColor: "grey9",
  paddingTop: "20px",
};

export const loadingIndicatorContainer = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 2000,
};

export const checkmarkIcon = {
  paddingRight: "10px",
  display: "inline",
};
